import './VKbd.sass'

import { createSimpleFunctional } from '@/util'

export const VKbd = createSimpleFunctional('v-kbd')

export type VKbd = InstanceType<typeof VKbd>
